import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="footer-content flex flex-align-center flex-between">
                    <small>Copyright © Assessment AI 2026</small>
                    <Link to="/usage-considerations" className="footer-link">
                        Usage Considerations
                    </Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
